import { render, staticRenderFns } from "./editLeaveType.vue?vue&type=template&id=225fd033&scoped=true"
import script from "./editLeaveType.vue?vue&type=script&lang=js"
export * from "./editLeaveType.vue?vue&type=script&lang=js"
import style0 from "./editLeaveType.vue?vue&type=style&index=0&id=225fd033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225fd033",
  null
  
)

export default component.exports